import {
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
} from "@mui/material";
import { FormControl } from "@mui/base";
import React from "react";

type RadioButton = {
  label: React.ReactNode;
  value: string;
};

export interface RadioButtonsProps extends RadioGroupProps {
  label?: React.ReactNode;
  options: RadioButton[];
}

export const RadioButtons = (props: RadioButtonsProps) => {
  const { label, options, ...radioGroupProps } = props;

  return (
    <FormControl>
      {label && (
        <label className="subtitle mb-4 text-base font-semibold">{label}</label>
      )}
      <RadioGroup {...radioGroupProps}>
        {props.options.map((option) => {
          return (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio color="primary" />}
              label={option.label}
              className={radioGroupProps.row ? "last:mr-0" : ""}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};
